import classNames from 'classnames';
import moment from 'moment-jalaali';

import {
  getPersianMonthName,
  getPersianWeekName,
} from '@utilities/persian-month';

import type { BookingDay } from './utils';

moment.loadPersian({ usePersianDigits: false });

type DayCardProps = {
  day: BookingDay;
  selected: boolean;
  id?: string;
  onSelect: (day: BookingDay) => void;
};

const DayCard = ({ day, selected, id, onSelect }: DayCardProps) => {
  const dayWeekName = getPersianWeekName(moment(day.date).day());
  const dayNumber = moment(day.date).format('jD');
  const monthName = getPersianMonthName(moment(day.date).jMonth());
  const today = moment().startOf('day');
  const cardDate = moment(day.date).startOf('day');
  const isDisabled =
    cardDate.isBefore(today) || day.isFullyBooked || day.totalCapacity === 0;

  return (
    <button
      type="button"
      id={id}
      disabled={isDisabled}
      onClick={() => onSelect(day)}
      data-testid={`healthcare-select-date-${day.date}`}
      className={classNames(
        'flex h-[88px] w-[88px] max-h-[88px] flex-col items-center justify-between rounded-xl border-[1.5px] border-border-primary bg-surface-primary p-2 text-Body/xSmall text-content-primary',
        selected && 'border-content-primary bg-surface-secondary',
        isDisabled &&
          'cursor-not-allowed border-none !bg-surface-disabled !text-content-disabled',
      )}
    >
      <span>{dayWeekName}</span>
      <span className="flex items-center gap-x-1">
        <span
          className={classNames(
            selected ? 'text-Label/Large' : 'text-Label/Small',
          )}
        >
          {dayNumber}
        </span>
        {!selected && <span className="text-Label/Small">{monthName}</span>}
      </span>
      <span className="text-nowrap">
        {day.totalCapacity.toLocaleString('fa-IR')} ظرفیت خالی
      </span>
    </button>
  );
};

export default DayCard;
